export const PARTICIPANT_ADD_PROPERTIES_KEYS = {
  AWAY_MESSAGE: 'awayMessage',
  MEETING_TYPE_SLUG: 'meetingTypeSlug',
}

export const FALLBACK_ACTION_TYPES = {
  UNAVAILABLE_CHAT_ACTION: 'unavailableChatAction',
  UNAVAILABLE_SCHEDULING_ACTION: 'unavailableSchedulingAction',
  OFFLINE_TEAM_ACTION_RULE_LEVEL: 'offlineTeamAction',
  UNRESPONSIVE_TEAM_ACTION: 'unresponsiveTeamAction',
  UNRESPONSIVE_TEAMMATES_ACTION: 'unresponsiveTeammatesAction',
  OFFLINE_TEAM_ACTION_TEAM_LEVEL: 'offlineTeamActionTeamLevel',
}

export const AVAILABILITY_MODES = {
  ALWAYS_ONLINE: 'Always available',
  ALWAYS_OFFLINE: 'Always away',
  CUSTOM_HOURS: 'Custom hours',
}

export const UserSelectType = {
  OWNER: 'OWNER',
  TEAM: 'TEAM',
  USERS: 'USERS',
  DEFAULT: 'DEFAULT',
}

export const AVAILABILITY_DAY_RANGES = {
  EVERYDAY: 'Everyday',
  WEEKDAYS: 'Weekdays',
  WEEKENDS: 'Weekends',
  MONDAY: 'Monday',
  TUESDAY: 'Tuesday',
  WEDNESDAY: 'Wednesday',
  THURSDAY: 'Thursday',
  FRIDAY: 'Friday',
  SATURDAY: 'Saturday',
  SUNDAY: 'Sunday',
}

// Edge cases include: TEAM_DEFAULT, DO_NOTHING
export const FALLBACK_ACTION_OPTIONS = {
  CALENDAR_DROP: {
    addType: 'CALENDAR_DROP',
    flowUpdate: 'STOP',
    delayLength: 30000,
    participantAddProperties: {
      awayMessage: 'Looks like my team is unavailable right now!',
      meetingTypeSlug: 'meeting',
    },
  },
  AWAY_MESSAGE: {
    addType: 'AWAY_MESSAGE',
    flowUpdate: 'STOP',
    participantAddProperties: {
      awayMessage: 'Looks like my team is unavailable right now!',
    },
  },
  CREATE_TICKET: {
    addType: 'CREATE_TICKET',
    flowUpdate: 'STOP',
    participantAddProperties: {
      awayMessage:
        "Looks like my team is unavailable right now! Create a ticket and we'll get back to you in no time ⏰",
    },
  },
  NEXT_RULE: {
    addType: 'NONE',
    flowUpdate: 'NEXT_RULE',
  },
  ROUTE_ANYWAY: {
    addType: 'ADD_ONE',
    flowUpdate: 'STOP',
  },
  END_ROUTING: {
    addType: 'NONE',
    flowUpdate: 'STOP',
  },
  REROUTE_WITHIN_TEAM: {
    addType: 'REROUTE_WITHIN_TEAM',
    delayLength: 30000,
  },
  DISREGARD: {
    addType: 'DISREGARD',
    flowUpdate: 'STOP',
  },
  TEAM_DEFAULT: null,
  DO_NOTHING: null,
}

/*
 Default: 'CALENDAR_DROP'
 Values correspond to FALLBACK_ACTION_OPTIONS
*/
export const CHAT_FALLBACK_OPTIONS = [
  { label: 'Schedule a meeting', value: 'CALENDAR_DROP' },
  { label: 'Send an away message', value: 'AWAY_MESSAGE' },
  { label: 'Create a ticket', value: 'CREATE_TICKET' },
  { label: 'Continue to next rule', value: 'NEXT_RULE' },
  { label: 'Route anyways', value: 'ROUTE_ANYWAY' },
]

/*
 Default: 'NEXT_RULE'
 Values correspond to FALLBACK_ACTION_OPTIONS
*/
export const SCHEDULING_FALLBACK_OPTIONS = [
  { label: 'Continue to next rule', value: 'NEXT_RULE' },
  { label: 'Send an away message', value: 'AWAY_MESSAGE' },
  {
    label: "End routing here - don't continue to next rule",
    value: 'END_ROUTING',
  },
]

/*
 Default: 'TEAM_DEFAULT'
 Values correspond to FALLBACK_ACTION_OPTIONS
*/
export const OFFLINE_TEAM_FALLBACK_OPTIONS = [
  { label: 'Team default', value: 'TEAM_DEFAULT' },
  { label: 'Continue to next rule', value: 'NEXT_RULE' },
  { label: 'Disregard team status', value: 'DISREGARD' },
]

/*
 Default: 'CALENDAR_DROP'
 Values correspond to FALLBACK_ACTION_OPTIONS
*/
export const OFFLINE_TEAM_FALLBACK_OPTIONS_TEAM_LEVEL = [
  { label: 'Schedule a meeting', value: 'CALENDAR_DROP' },
  { label: 'Send an away message', value: 'AWAY_MESSAGE' },
  { label: 'Create a ticket', value: 'CREATE_TICKET' },
  { label: 'Do nothing', value: 'DO_NOTHING' },
]

/*
 Default: 'DO_NOTHING'
 Values correspond to FALLBACK_ACTION_OPTIONS
*/
export const UNRESPONSIVE_TEAM_FALLBACK_OPTIONS = [
  { label: 'Schedule a meeting', value: 'CALENDAR_DROP' },
  { label: 'Continue to next rule', value: 'NEXT_RULE' },
  { label: 'Send an away message', value: 'AWAY_MESSAGE' },
  { label: 'Create a ticket', value: 'CREATE_TICKET' },
  { label: 'Re-route within the same team', value: 'REROUTE_WITHIN_TEAM' },
  { label: 'Do nothing', value: 'DO_NOTHING' },
]

/*
 Default: 'DO_NOTHING'
 Values correspond to FALLBACK_ACTION_OPTIONS
*/
export const UNRESPONSIVE_TEAMMATES_FALLBACK_OPTIONS = [
  { label: 'Schedule a meeting', value: 'CALENDAR_DROP' },
  { label: 'Continue to next rule', value: 'NEXT_RULE' },
  { label: 'Send an away message', value: 'AWAY_MESSAGE' },
  { label: 'Create a ticket', value: 'CREATE_TICKET' },
  { label: 'Re-route within the same teammates', value: 'REROUTE_WITHIN_TEAM' },
  { label: 'Do nothing', value: 'DO_NOTHING' },
]

/*
 Default: 'DO_NOTHING'
 Values correspond to FALLBACK_ACTION_OPTIONS
*/
export const UNRESPONSIVE_OWNER_FALLBACK_OPTIONS = [
  { label: 'Schedule a meeting', value: 'CALENDAR_DROP' },
  { label: 'Continue to next rule', value: 'NEXT_RULE' },
  { label: 'Send an away message', value: 'AWAY_MESSAGE' },
  { label: 'Create a ticket', value: 'CREATE_TICKET' },
  { label: 'Do nothing', value: 'DO_NOTHING' },
]

export const DEFAULT_UNAVAILABLE_CHAT_ACTION =
  FALLBACK_ACTION_OPTIONS.CALENDAR_DROP

export const DEFAULT_UNAVAILABLE_CHAT_ACTION_OWNER =
  FALLBACK_ACTION_OPTIONS.NEXT_RULE

export const DEFAULT_OFFLINE_TEAM_ACTION = FALLBACK_ACTION_OPTIONS.CALENDAR_DROP

export const DEFAULT_OFFLINE_TEAM_ACTION_RULE_LEVEL =
  FALLBACK_ACTION_OPTIONS.TEAM_DEFAULT

export const DEFAULT_SCHEDULING_ACTION = FALLBACK_ACTION_OPTIONS.NEXT_RULE

export const DEFAULT_UNRESPONSIVE_ACTION =
  FALLBACK_ACTION_OPTIONS.REROUTE_WITHIN_TEAM

export const DEFAULT_UNRESPONSIVE_ACTION_OWNER =
  FALLBACK_ACTION_OPTIONS.CALENDAR_DROP

// Default: 'NEXT_RULE'
// NOTE: 'AWAY_MESSAGE' corresponds to addType instead of flowUpdate, this is necessary to avoid duplicate values.
export const SCHEDULING_OPTIONS = [
  { label: 'Continue to next rule', value: 'NEXT_RULE' },
  { label: "End routing here - don't continue to next rule", value: 'STOP' },
  { label: 'Send an away message', value: 'AWAY_MESSAGE' },
]

export const EXCLUDED_FIELDS = Object.freeze([
  'autoAssigneeId',
  'cookie',
  'daysSinceLastVisit',
  'device',
  'exitIntent',
  'secondsOnPage',
  'secondsOnSite',
  'siteVisits',
])

export const ConditionOptions = {
  CUSTOM: 'CUSTOM',
  SFDC: 'SFDC',
  LEANDATA: 'LEANDATA',
  ABM: 'ABM',
  SFDC_OWNER: 'SFDC_OWNER',
}

// TODO: add SFDC owner participant action
export const ConditionOptionToAction = {
  [ConditionOptions.CUSTOM]: undefined,
  [ConditionOptions.SFDC]: { type: 'SALESFORCE_PARTICIPANT', options: {} },
  [ConditionOptions.LEANDATA]: { type: 'LEANDATA_PARTICIPANT', options: {} },
  [ConditionOptions.ABM]: { type: 'ABM_PARTICIPANT', options: {} },
}

export const ActionTypeToConditionOption = {
  ABM_PARTICIPANT: ConditionOptions.ABM,
  PARTICIPANT: ConditionOptions.CUSTOM,
  EXECUTE_RULE_GROUP: ConditionOptions.CUSTOM,
  SALESFORCE_PARTICIPANT: ConditionOptions.SFDC,
  SALESFORCE_OWNER_PARTICIPANT: ConditionOptions.SFDC_OWNER,
  LEANDATA_PARTICIPANT: ConditionOptions.LEANDATA,
}

export const DraftSaveTrackTypes = {
  CONDITION: 'CONDITION',
  ACTION: 'ACTION',
}

export const DraftSaveModalType = {
  V1: 'V1',
  V2: 'V2',
}

// Multi-owner select options
export const SalesforceOwnerSelectOption = {
  label: 'Salesforce',
  value: 'SALESFORCE_OWNER_PARTICIPANT',
}
export const DriftOwnerSelectOption = {
  label: 'Drift',
  value: 'ABM_PARTICIPANT',
}
export const MultiOwnerSelectOptions = [
  SalesforceOwnerSelectOption,
  DriftOwnerSelectOption,
]

export const AdminOrgs = {
  SALESLOFT: 13799,
  DRIFT: 1,
}
